module.exports = ".container-fluid {\n  padding: 0;\n}\n.body-navigation {\n  background-color: #4c2f6a;\n  width: 220px;\n}\n.body-content {\n  background-color: #e4e9ee;\n  min-height: 100vh;\n}\n@media (min-width: 992px) {\n  .body-navigation {\n    height: 100%;\n    position: fixed;\n  }\n  .body-content {\n    padding-left: 220px;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/main/layout.main.component.less
// module id = ./src/app/layouts/main/layout.main.component.less
// module chunks = main